module.exports = __webpack_public_path__ + "static/media/jeeurope.edb4de24.png";